<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="详情"
      width="1100px"
      top="10vh"
      class="bom-preview"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="bom"
        class="form"
        label-width="80px">
      <el-row>
        <div style="font-size: 14px; margin-top: 10px">基本信息</div>
        <el-divider/>
        <el-col :span="12">
          <el-form-item label="类型" prop="bomType" style="margin-bottom: 13px" disabled>
            <el-select v-model="bom.bomType" placeholder="">
              <el-option label="销售BOM" :value="10"/>
              <el-option label="生产BOM" :value="20"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料名称" prop="materialName" disabled>
            <el-input v-model="bom.materialName" readonly/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料编号">
            <el-input v-model="bom.materialNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位">
            <el-input v-model="bom.measuringUnitName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编号">
            <el-input v-model="bom.bomNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="版本号">
            <el-input v-model="bom.versionNo" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div style="font-size: 14px; margin-top: 10px">子物料信息</div>

        <el-divider/>
        <div style="text-align: right;margin-right: 20px;">
          合计:<span>{{totalAmount.toFixed(2)}}</span>
        </div>
        <el-table 
            class="childMetrialTable" 
            :data="bom.bomDetails" 
            border
            :height="bom.bomDetails.length >= 10 ? '400' : ''">
          <el-table-column type="index" label="#" align="center" width="55"/>
          <el-table-column
              prop="materialNo"
              width="140"
              align="left"
              show-overflow-tooltip
              label="子物料编号"/>
          <el-table-column prop="specification" align="left" show-overflow-tooltip label="规格型号"/>
          <el-table-column prop="materialName" align="left" show-overflow-tooltip label="子物料名称"/>
          <el-table-column prop="price" label="采购单价" align="center" width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.price"/>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" align="center" width="100" label="用量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.quantity" disabled/>
            </template>
          </el-table-column>
          <el-table-column
              prop="measuringUnitName"
              align="center"
              width="80"
              show-overflow-tooltip
              label="单位">
            <template slot-scope="scope">
              <span v-if="scope.row.measuringUnitName">{{scope.row.measuringUnitName}}</span>
              <span v-else/>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="采购价" align="center" width="100">
            <template slot-scope="scope">
              <span>{{(scope.row.quantity * scope.row.price).toFixed(2)}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "MaterialBomPreview",
    data() {
      return {
        dialogVisible: false,
        bom: {
          pkId: 0,
          bomNo: "",
          materialName: "",
          materialNo: "",
          bomType: "",
          versionNo: "",
          measuringUnitName: "",
          bomDetails: [],
        },
      };
    },
    computed:{
      totalAmount() {
        var amount = 0;
        this.bom.bomDetails.forEach((item) => {
          amount = amount + item.quantity * item.price;
        });
        return amount;
      },
    },

    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.getData(row.materialNO);
        }
      },

      // 根据物料id生成BOM编号和版本号
      getData(materialNo) {
        this.$http.get("basic", `boms/selectByMaterialNo/${materialNo}`).then((resp) => {
          if (resp.success) {
            this.bom = resp.data;
          }
        });
      },

    },
  };
</script>

<style lang="scss">
.bom-preview .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.bom-preview .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.bom-preview .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.bom-preview .el-divider--horizontal {
  margin: 10px 0;
}

.bom-preview .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.bom-preview .childMetrialTable .el-input__inner {
  text-align: center;
}

.bom-preview .childMetrialTable .price .el-input__inner {
  text-align: left;
}
</style>